module.exports = __webpack_public_path__ + "static/media/3.a30447fe.jpeg";